import ReadWriteRecipientViewState from 'owa-recipient-types/lib/types/ReadWriteRecipientViewState';
import FindControlViewState from 'owa-recipient-types/lib/types/FindControlViewState';
import { getReadWriteRecipientViewStateFromRecipientAddressString } from 'owa-recipient-create-viewstate/lib/util/getReadWriteRecipientViewStateFromRecipientAddressString';
import { splitPasteInputIntoRecipientStrings } from './splitPasteInputIntoRecipientStrings';

export default function parsePastedTextForRecipients(
    recipientWell: FindControlViewState,
    pastedText: string
): ReadWriteRecipientViewState[] {
    let recipientList = splitPasteInputIntoRecipientStrings(pastedText);
    return recipientList.map(getReadWriteRecipientViewStateFromRecipientAddressString);
}
